import { Controller } from "@hotwired/stimulus";

const HEX = /^#[0-9a-f]{6}$/i;

export default class extends Controller {
  static targets = ["swatch", "input"];
  static values = { defaultColor: String };

  copyFromSwatch() {
    this.inputTarget.value = this.swatchTarget.value;
    this.dispatch("change");
  }

  copyFromText() {
    if (!HEX.test(this.inputTarget.value)) return;

    this.swatchTarget.value = this.inputTarget.value;
    this.dispatch("change");
  }

  revert() {
    this.inputTarget.value = this.swatchTarget.value;
  }

  reset() {
    this.swatchTarget.value = this.defaultColorValue;
    this.copyFromSwatch();
  }
}
